module.exports = require("./ha-GH.d.ts");